var _circle, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpinner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.5,
    cy: 20.5,
    r: 20,
    stroke: "url(#paint0_linear_4497_5839)",
    strokeWidth: 0.444444
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#paint1_angular_4497_5839_clip_path)",
    "data-figma-skip-parse": "true"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(9.6899e-10 -0.0184444 0.0184444 9.6899e-10 20.5 20.5)"
  }, /*#__PURE__*/React.createElement("foreignObject", {
    x: -1138.55,
    y: -1138.55,
    width: 2277.11,
    height: 2277.11
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      background: "conic-gradient(from 90deg,rgba(248, 230, 193, 1) 0deg,rgba(248, 230, 193, 1) 164.44deg,rgba(248, 230, 193, 0) 360deg)",
      height: "100%",
      width: "100%",
      opacity: 1
    }
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.5 20.5H40C40 31.2696 31.2696 40 20.5 40V40.5V41C31.8218 41 41 31.8218 41 20.5H40.5ZM20.5 40.5V40C9.73045 40 1 31.2696 1 20.5H0.5H0C0 31.8218 9.17816 41 20.5 41V40.5ZM0.5 20.5H1C1 9.73045 9.73045 1 20.5 1V0.5V0C9.17816 0 0 9.17816 0 20.5H0.5ZM20.5 0.5V1C31.2696 1 40 9.73045 40 20.5H40.5H41C41 9.17816 31.8218 0 20.5 0V0.5Z",
    "data-figma-gradient-fill": "{\"type\":\"GRADIENT_ANGULAR\",\"stops\":[{\"color\":{\"r\":0.97254902124404907,\"g\":0.90196079015731812,\"b\":0.75686275959014893,\"a\":1.0},\"position\":0.0},{\"color\":{\"r\":0.97254902124404907,\"g\":0.90196079015731812,\"b\":0.75686275959014893,\"a\":1.0},\"position\":0.45677769184112549},{\"color\":{\"r\":0.97254902124404907,\"g\":0.90196079015731812,\"b\":0.75686275959014893,\"a\":0.0},\"position\":1.0}],\"transform\":{\"m00\":1.9379799596208613e-06,\"m01\":36.888889312744141,\"m02\":2.0555543899536133,\"m10\":-36.888889312744141,\"m11\":1.9379808691155631e-06,\"m12\":38.944442749023438},\"opacity\":1.0,\"blendMode\":\"NORMAL\",\"stopsVar\":[{\"color\":{\"r\":0.97254902124404907,\"g\":0.90196079015731812,\"b\":0.75686275959014893,\"a\":1.0},\"position\":0.0},{\"color\":{\"r\":0.97254902124404907,\"g\":0.90196079015731812,\"b\":0.75686275959014893,\"a\":1.0},\"position\":0.45677769184112549},{\"color\":{\"r\":0.97254902124404907,\"g\":0.90196079015731812,\"b\":0.75686275959014893,\"a\":0.0},\"position\":1.0}],\"visible\":true}"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "paint1_angular_4497_5839_clip_path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.5 20.5H40C40 31.2696 31.2696 40 20.5 40V40.5V41C31.8218 41 41 31.8218 41 20.5H40.5ZM20.5 40.5V40C9.73045 40 1 31.2696 1 20.5H0.5H0C0 31.8218 9.17816 41 20.5 41V40.5ZM0.5 20.5H1C1 9.73045 9.73045 1 20.5 1V0.5V0C9.17816 0 0 9.17816 0 20.5H0.5ZM20.5 0.5V1C31.2696 1 40 9.73045 40 20.5H40.5H41C41 9.17816 31.8218 0 20.5 0V0.5Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4497_5839",
    x1: 8.94444,
    y1: 36.7222,
    x2: 29.1667,
    y2: 2.05555,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.448403,
    stopColor: "#A59B80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F3B31"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinner);
export default __webpack_public_path__ + "static/media/spinner.92a2f23e33db5c095b9c18729606c766.svg";
export { ForwardRef as ReactComponent };